import React from 'react'
import cn from 'classnames'

import { IButtonDefaultProps } from './interface'
import './styles.scss'

export const baseClass = 'base-button-default'

export const ButtonDefault: React.FC<IButtonDefaultProps> = props => {
  const {
    children,
    className,
    xs,
    sm,
    lg,
    primary,
    secondary,
    float,
    danger,
    remove,
    submitting,
    icon,
    outline,
    type = 'button',
    title,
    stretched,
    wrapped,
    isLast,
    tabIndex,
    outlineSecondary,
    ...rest
  }: IButtonDefaultProps = props

  return (
    <button
      {...rest}
      tabIndex={tabIndex}
      title={title}
      type={type}
      className={cn(
        baseClass,
        {
          [`${baseClass}__xs`]: xs,
          [`${baseClass}__sm`]: sm,
          [`${baseClass}__lg`]: lg,
          [`${baseClass}__primary`]: primary,
          [`${baseClass}__secondary`]: secondary,
          [`${baseClass}__float`]: float,
          [`${baseClass}__danger`]: danger,
          [`${baseClass}__remove`]: remove,
          [`${baseClass}__submitting`]: submitting,
          [`${baseClass}__outline`]: outline,
          [`${baseClass}__stretched`]: stretched,
          [`${baseClass}__wrapped`]: wrapped,
          [`${baseClass}__last`]: isLast,
          [`${baseClass}__outline__secondary`]: outlineSecondary,
        },
        className
      )}
    >
      {!!icon && <span className={`${baseClass}__icon`}>{icon}</span>}
      {children}
    </button>
  )
}

export default ButtonDefault
